module.exports = __webpack_public_path__ + "static/media/logo-home-affairs.0eef90bd.png";